"use client";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
const t = ({
  title: r,
  titleId: i,
  desc: n,
  descId: o,
  ...l
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...l,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      r ? /* @__PURE__ */ e("title", { id: i, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M3.9701 10.8187c-.5572-.2167-.8358-.3251-.9171-.4812a.468.468 0 0 1-.0003-.432c.0811-.1562.3596-.2648.9166-.4822L19.775 3.2552c.5028-.1962.7541-.2943.9148-.2407a.468.468 0 0 1 .2956.2956c.0536.1606-.0445.412-.2407.9148l-6.1681 15.8058c-.2174.557-.326.8354-.4822.9166a.468.468 0 0 1-.432-.0003c-.1561-.0813-.2645-.3599-.4812-.9171l-2.4597-6.325c-.044-.1132-.066-.1697-.0999-.2173a.47.47 0 0 0-.1093-.1093c-.0476-.0339-.1041-.0559-.2173-.0999z"
        }
      )
    ]
  }
);
export {
  t as default
};
